import { DEFAULT_MAX_AUTOCOMPLETE_RESULT_LIMIT } from 'Config';

interface IInfiniteScrollLoaderHandler {
  event: React.UIEvent<HTMLElement>;
  scrollIndex: number;
  setScrollIndex: Function;
  optionsLength: number;
}

export const infiniteScrollLoaderHandler = ({
  event,
  optionsLength,
  scrollIndex,
  setScrollIndex,
}: IInfiniteScrollLoaderHandler) => {
  const element = event.target as HTMLElement;
  const { scrollTop, scrollHeight, clientHeight } = element;
  const scrollPercentage: number =
    (scrollTop / (scrollHeight - clientHeight)) *
    DEFAULT_MAX_AUTOCOMPLETE_RESULT_LIMIT;

  if (scrollPercentage === 0 && scrollIndex > 0)
    setScrollIndex(scrollIndex - 1);
  else if (
    scrollPercentage >= 99 &&
    scrollIndex * DEFAULT_MAX_AUTOCOMPLETE_RESULT_LIMIT < optionsLength
  )
    setScrollIndex(scrollIndex + 1);
};
